import { render, staticRenderFns } from "./AvatarInput.vue?vue&type=template&id=2f2a4fd1&scoped=true&"
import script from "./AvatarInput.vue?vue&type=script&lang=ts&"
export * from "./AvatarInput.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarInput.vue?vue&type=style&index=0&id=2f2a4fd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2a4fd1",
  null
  
)

export default component.exports